import React, { useState } from 'react';

const Footer = () => {
  const [clickCount, setClickCount] = useState(0);

  const createConfetti = () => {
    const colors = ['#01FF00', '#00cc00', '#ffffff', '#8b949e'];
    for (let i = 0; i < 30; i++) {
      setTimeout(() => {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = (Math.random() * window.innerWidth) + 'px';
        confetti.style.top = '-10px';
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDelay = (Math.random() * 0.5) + 's';
        document.body.appendChild(confetti);

        setTimeout(() => confetti.remove(), 3000);
      }, i * 20);
    }
  };

  const showSecretMessage = () => {
    const message = document.createElement('div');
    message.className = 'secret-message';
    message.innerHTML = `
      <h3>🎊 Gratulacje! 🎊</h3>
      <p>Znalazłeś sekretną wiadomość!<br>Jesteś prawdziwym odkrywcą.</p>
      <button onclick="this.parentElement.remove()">Zamknij</button>
    `;
    document.body.appendChild(message);
    setTimeout(() => message.classList.add('show'), 10);

    setTimeout(() => {
      message.classList.remove('show');
      setTimeout(() => message.remove(), 500);
    }, 5000);
  };

  const handleYearClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    createConfetti();

    if (newCount >= 5) {
      showSecretMessage();
      setClickCount(0);
    }
  };

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h4>Dane działalności</h4>
          <ul>
            <li className="footer-business-name">MESPI Igor Miszczak</li>
            <li className="footer-business-item">NIP: 9112052633</li>
            <li>
              <a href="mailto:business@mespi.dev">business@mespi.dev</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Strony</h4>
          <ul>
            <li><a href="#about">O nas</a></li>
            <li><a href="#projects">Projekty</a></li>
            <li><a href="#skills">Usługi</a></li>
            <li><a href="#contact">Kontakt</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Social Media</h4>
          <ul>
            <li>
              <a
                href="https://github.com/Meszpo"
                target="_blank"
                rel="noopener noreferrer"
                className="link-with-icon"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-github"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5" /></svg>
                GitHub
              </a>
            </li>
            <li>
              <a
                href="https://linkedin.com/in/igor-miszczak"
                target="_blank"
                rel="noopener noreferrer"
                className="link-with-icon"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-linkedin"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 11v5" /><path d="M8 8v.01" /><path d="M12 16v-5" /><path d="M16 16v-3a2 2 0 1 0 -4 0" /><path d="M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4l0 -10" /></svg>
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          ©{' '}
          <span className="secret-year" style={{ cursor: 'pointer' }} onClick={handleYearClick}>
            2026
          </span>{' '}
          Mespi.dev. Wszystkie prawa zastrzeżone. | Tworzymy przyszłość cyfrową.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
